/**
 * @generated SignedSource<<3a496ec20d20f082ac795f237770515e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BrandTileIcon_branding$data = {
  readonly tile: {
    readonly url: AGG$URL | null;
  } | null;
  readonly " $fragmentType": "BrandTileIcon_branding";
};
export type BrandTileIcon_branding$key = {
  readonly " $data"?: BrandTileIcon_branding$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandTileIcon_branding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BrandTileIcon_branding",
  "selections": [
    {
      "concreteType": "CustomerServiceBrandingTile",
      "kind": "LinkedField",
      "name": "tile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ]
    }
  ],
  "type": "CustomerServiceBranding"
};

(node as any).hash = "de388716609f5d80310df1e713c995ad";

export default node;
